<template>
	<div>
		<el-row>
			<el-form :inline="true" :model="params"
				><ScreeCompany
					ref="ScreeCompany"
					:allowField="allowField"
					@ScreeCompany="ScreeCompany"
				/>
				<el-form-item label="时间">
					<el-date-picker
						:picker-options="{
							disabledDate,
						}"
						format="yyyy 年 MM 月"
						value-format="yyyyMM"
						v-model="params.month"
						type="month"
						placeholder="选择月"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<div class="btn-box">
						<el-button
							:loading="downloadLoading"
							style="margin: 0 0 0px 20px"
							type="primary"
							size="medium"
							icon="el-icon-document"
							@click="handleDownload"
						>
							导出收入信息表
						</el-button>
						<getIdentity :params="params" />
					</div>
				</el-form-item>
			</el-form>
		</el-row>
	</div>
</template>

<script>
import moment from "moment";
import ScreeCompany from "@/components/ScreeCompany.vue";
import getIdentity from "./getIdentity.vue";
export default {
	components: {
		ScreeCompany,
		getIdentity,
	},
	props: {},
	data() {
		return {
			downloadLoading: false,
			list: [],
			allowField: ["settlementId"],
			columns: [
				{
					title: "是否已取得登记证照",
					value: "is_registration",
				},
				{
					title: "名称（已取得登记证照）",
					value: "y_name",
				},
				{
					title: "统一社会信用代码（纳税人识别号）（已取得登记证照）",
					value: "y_tax_no",
				},
				{
					title: "姓名（未取得登记证照）",
					value: "fullname",
				},
				{
					title: "证件类型（未取得登记证照）",
					value: "id_card_type",
				},
				{
					title: "证件号码（未取得登记证照）",
					value: "id_card",
				},
				{
					title: "国家或地区（未取得登记证照）",
					value: "country",
				},
				{
					title: "收入来源的互联网平台名称",
					value: "internet_platform",
				},
				{
					title: "收入来源的店铺（用户）名称",
					value: "customer_name",
				},
				{
					title: "收入来源的店铺（用户）唯一标识码",
					value: "customer_id",
				},
				{
					title: "销售货物取得的收入总额（已取得登记证照）",
					value: "y_goods_income",
				},
				{
					title: "销售货物取得的收入退款金额（已取得登记证照）",
					value: "y_goods_refund_income",
				},
				{
					title: "销售货物取得的收入净额（已取得登记证照）",
					value: "y_goods_net_income",
				},
				{
					title: "销售无形资产取得的收入总额（已取得登记证照）",
					value: "y_intangible_income",
				},
				{
					title: "销售无形资产取得的收入退款金额（已取得登记证照）",
					value: "y_intangible_refund_income",
				},
				{
					title: "销售无形资产取得的收入净额（已取得登记证照）",
					value: "y_intangible_net_income",
				},
				{
					title: "销售服务取得的收入总额（已取得登记证照）",
					value: "y_service_income",
				},
				{
					title: "销售服务取得的收入退款金额（已取得登记证照）",
					value: "y_service_refund_income",
				},
				{
					title: "销售服务取得的收入净额（已取得登记证照）",
					value: "y_service_net_income",
				},
				{
					title: "收入总额（未取得登记证照）",
					value: "income",
				},
				{
					title: "退款金额（未取得登记证照）",
					value: "refund_income",
				},
				{
					title: "小计（未取得登记证照）",
					value: "subtotal",
				},
				{
					title: "销售货物收入（未取得登记证照）",
					value: "goods_income",
				},
				{
					title: "运输服务收入（未取得登记证照）",
					value: "transport_service_income",
				},
				{
					title: "劳务报酬（未取得登记证照）",
					value: "labor_income",
				},
				{
					title: "稿酬（未取得登记证照）",
					value: "manuscript_income",
				},
				{
					title: "特许权使用费（未取得登记证照）",
					value: "royalties_income",
				},
				{
					title: "从事其他网络交易活动取得的收入（净额）",
					value: "other_income",
				},
				{
					title: "支付给平台的佣金，服务费合计金额",
					value: "commission_income",
				},
				{
					title: "交易数量",
					value: "order_num",
				},
			],
			params: {
				month: "",
				channel_account: "",
			},
		};
	},

	computed: {},

	methods: {
		ScreeCompany(option, key) {
			console.log(option, key);
			if (key === "settlement") {
				this.params.channel_account = option;
			}
		},
		disabledDate(time) {
			return time.getTime() > Date.now();
		},
		//导出
		async handleDownload() {
			try {
				let falg = await this.init("export");
				if (!falg) {
					return;
				}
				console.log(this.list, "list");
				import("@/excel/Export2Excel").then((excel) => {
					let sHeader = this.columns.map((item) => item.title);
					const data = this.formatJson(this.list);
					const time = new Date().getTime() + Math.random() * 1000;
					let filename = `导出收入信息表${time}`;
					excel.export_json_to_excel({
						header: sHeader, //Header Required
						data, //Specific data Required
						filename: filename, //Optional
						autoWidth: true, //Optional
						bookType: "xlsx", //Optional
					});
					this.downloadLoading = false;
				});
			} catch (error) {
				this.downloadLoading = false;
			}
		},
		//转换导出数据
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let tempArr = [];
				this.columns.map((item) => {
					tempArr.push(v[item.value]);
				});
				return tempArr;
			});
		},
		checkParams() {
			if (!this.params.month) {
				this.$message.error("请选择时间");
				return false;
			}
			if (!this.params.channel_account) {
				this.$message.error("请选择税源地");
				return false;
			}
			return true;
		},
		// 初始化列表
		async init() {
			if (!this.checkParams()) {
				return;
			}
			let params = this.params;
			this.downloadLoading = true;
			let data = await this.$api.get_qxy_tax_export_declare_income(params);

			this.list = data;
			return true;
		},
	},
	created() {},
	mounted() {
		this.params.month = moment()
			.subtract(1, "M")
			.format("yyyyMM");
	},
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
	margin-bottom: 0;
}
.tip {
	display: flex;
	font-size: 16px;
	margin-bottom: 24px;
	.dan-tip {
		margin-left: 24px;
		color: #d9001b;
	}
}
.name {
	cursor: pointer;
	color: #409eff;
}
.flex-bw {
	display: flex;
	justify-content: space-between;
}
.btn-box {
	width: 360px;
	flex: none;
}
.table-right {
	float: right;
}
.btn-box {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
</style>
